<template>
  <div class="pb-2">
    <v-row v-for="db in langdb[$i18n.locale]" :key="db.type" no-gutters>
      <v-col cols="2" class="pa-0">
        <span class="text-caption mb-0 liiblack--text text--lighten-4 pl-2">{{$t(`home.${db.type}`)}}</span>
      </v-col>
      <v-col cols="10" class="pa-0" >
        <v-chip-group column>
          <v-chip label v-for="item in db.links" :key="item.name" class="liiblack pa-0 my-0 mx-1">
            <router-link :to="item.path" class="shortcut-links py-1 px-2">{{item.name}}</router-link>
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
  </div>
</template>


<script>
  export default {
    name: 'HomeShortcut',
    props:{
    },
    data(){
      return {
        langdb: {
          en: [ 
            {
              'type': 'judgments', 
              'links':[
                {'path': '/en/cases/hkcfa/', 'name': 'HKCFA'},
                {'path': '/en/cases/ukpc/', 'name': 'UKPC'},
                {'path': '/en/cases/hkca/', 'name': 'HKCA'},
                {'path': '/en/cases/hkcfi/', 'name': 'HKCFI'},
                {'path': '/en/cases/hkdc/', 'name': 'HKDC'},
                {'path': '/en/cases/hkfc/', 'name': 'HKFC'},
                {'path': '/en/cases/hkct/', 'name': 'HKCT'},
                {'path': '/en/cases/hkldt/', 'name': 'HKLdT'},
              ]
            },
            {
              'type': 'judgments_altlang', 
              'links':[
                {'path': '/tc/cases/hkcfa/', 'name': '終審法院'},
                {'path': '/tc/cases/hkca/', 'name': '上訴法庭'},
                {'path': '/tc/cases/hkcfi/', 'name': '原訟法庭'},
                {'path': '/tc/cases/hkdc/', 'name': '區域法院'},
                {'path': '/tc/cases/hkfc/', 'name': '家事法庭'},
                {'path': '/tc/cases/hkct/', 'name': '競爭事務審裁處'},
                {'path': '/tc/cases/hkldt/', 'name': '土地審裁處'},
              ]
            },
            {
              'type': 'legislation', 
              'links':[
                {'name': 'Ordinances', 'path': '/en/legis/ord/'},
                {'name': 'Regulations', 'path': '/en/legis/reg/'},
                {'name': 'Constitutional Instruments', 'path': '/en/legis/instrument/'},
                {'name': 'Basic Law', 'path': '/en/legis/instrument/A101'},
              ]
            }
          ],
          tc: [ 
            {
              'type': 'judgments', 
              'links':[
                {'path': '/tc/cases/hkcfa/', 'name': '終審法院'},
                {'path': '/tc/cases/hkca/', 'name': '上訴法庭'},
                {'path': '/tc/cases/hkcfi/', 'name': '原訟法庭'},
                {'path': '/tc/cases/hkdc/', 'name': '區域法院'},
                {'path': '/tc/cases/hkfc/', 'name': '家事法庭'},
                {'path': '/tc/cases/hkct/', 'name': '競爭事務審裁處'},
                {'path': '/tc/cases/hkldt/', 'name': '土地審裁處'},
              ]
            },
            {
              'type': 'judgments_altlang', 
              'links':[
                {'path': '/en/cases/hkcfa/', 'name': 'HKCFA'},
                {'path': '/en/cases/ukpc/', 'name': 'UKPC'},
                {'path': '/en/cases/hkca/', 'name': 'HKCA'},
                {'path': '/en/cases/hkcfi/', 'name': 'HKCFI'},
                {'path': '/en/cases/hkdc/', 'name': 'HKDC'},
                {'path': '/en/cases/hkfc/', 'name': 'HKFC'},
                {'path': '/en/cases/hkct/', 'name': 'HKCT'},
                {'path': '/en/cases/hkldt/', 'name': 'HKLdT'},
              ]
            },
            {
              'type': 'legislation', 
              'links':[
                {'name': '條例', 'path': '/tc/legis/ord/'},
                {'name': '附屬法例', 'path': '/tc/legis/reg/'},
                {'name': '憲法文件', 'path': '/tc/legis/instrument/'},
                {'name': '基本法', 'path': '/tc/legis/instrument/A101'},
              ]
            }
          ],
          sc: [ 
            {
              'type': 'judgments', 
              'links':[
                {'path': '/tc/cases/hkcfa/', 'name': '終審法院'},
                {'path': '/tc/cases/hkca/', 'name': '上訴法庭'},
                {'path': '/tc/cases/hkcfi/', 'name': '原訟法庭'},
                {'path': '/tc/cases/hkdc/', 'name': '區域法院'},
                {'path': '/tc/cases/hkfc/', 'name': '家事法庭'},
                {'path': '/tc/cases/hkct/', 'name': '競爭事務審裁處'},
                {'path': '/tc/cases/hkldt/', 'name': '土地審裁處'},
              ]
            },
            {
              'type': 'judgments_altlang', 
              'links':[
                {'path': '/en/cases/hkcfa/', 'name': 'HKCFA'},
                {'path': '/en/cases/ukpc/', 'name': 'UKPC'},
                {'path': '/en/cases/hkca/', 'name': 'HKCA'},
                {'path': '/en/cases/hkcfi/', 'name': 'HKCFI'},
                {'path': '/en/cases/hkdc/', 'name': 'HKDC'},
                {'path': '/en/cases/hkfc/', 'name': 'HKFC'},
                {'path': '/en/cases/hkct/', 'name': 'HKCT'},
                {'path': '/en/cases/hkldt/', 'name': 'HKLdT'},
              ]
            },
            {
              'type': 'legislation', 
              'links':[
                {'name': '条例', 'path': '/sc/legis/ord/'},
                {'name': '附属法例', 'path': '/sc/legis/reg/'},
                {'name': '宪法文件', 'path': '/sc/legis/instrument/'},
                {'name': '基本法', 'path': '/sc/legis/instrument/A101'},
              ]
            }
          ],
        }
      }
    },
  }
</script>


<style scoped>
  .shortcut-links{
    color: white;
    text-decoration: none;
  }

  ::v-deep .v-chip__content :hover {
    background: var(--v-liiblack-lighten2);
    transition: 0.2s;
  }

  ::v-deep .v-chip-group .v-slide-group__content{
    padding-top: 0px;
    padding-bottom: 0px;
  }
</style>